import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Subscription } from 'rxjs';
import { Claims } from '../../../../_models/common/claims';
import { ClaimsService } from '../../../../_services/common/claims.service';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
    selector: 'formly-dropdown',
    templateUrl: "./formly-dropdown.component.html",
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, FormlyModule, TranslateModule, NgSelectModule]
})
export class FormlyDropdownComponent extends FieldType implements OnInit, OnDestroy {

    param: any;
    isFormSubmitted: boolean = false;
    formSubmissionSubscription: Subscription;
    fieldKey: string;
    claims: Claims;
    linkType: boolean = false;
    orgId: number;
    constructor(
        private dynamicFormService: DynamicFormService,
        private claimsService: ClaimsService,
        private sanitizer: DomSanitizer,
        private cdRef: ChangeDetectorRef
    ) {
        super();
        this.claimsService.currentClaims.subscribe(claims => {
            this.claims = claims;
            this.orgId = this.claims.OrgId;
        });
    }

    ngOnInit() {
        if (this.field.key) {
            this.fieldKey = this.field.id ?? this.field.key.toString();
            if (this.fieldKey == 'approverId')
                this.linkType = true;
        }
        this.formSubmissionSubscription = this.dynamicFormService.getFormSubmittedEvent().subscribe(data => {
            this.isFormSubmitted = data;
            this.cdRef.detectChanges();
        });
    }

    ngOnDestroy() {
        if (this.formSubmissionSubscription) {
            this.formSubmissionSubscription.unsubscribe();
        }
    }

    onValueChange() {
        if (this.to.change) {
            this.to.change(this.field, this.formControl.value);
        }
    }

    allowAcuteChar(e) {
        let regex = new RegExp("^[a-zA-ZÀ-ú\p{L} '-]+$");
        let str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
        if (regex.test(str)) {
            return true;
        }
        else return false;
    }

    omitSpecialChar(event) {

        if (this.field.templateOptions.allowAcuteChar) {
            return this.allowAcuteChar(event);
        }

    }

    fnOpenPanel() {
        this.to.click(this.field);
    }

    fnOpenSupportingLink(link: any) {
        if (link.onClick) {
            link.onClick();
        }
    }

    sanitizerHtml(element) {
        let safeText = this.sanitizer.bypassSecurityTrustHtml(element);
        return safeText;
    }

    clickAction() {
        if (this.to.attributes && this.to.attributes.isReadonly == 0) {
            if (this.to.onClick) {
                this.to.onClick(this.field, this.to.attributes.isReadonly)
            }
        }
    }

    onTinyClick() {
        this.to.onTinyClick();
    }
}